import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../style/Category.css";
import ad from '../assets/evitaraad.png';
import flight from '../assets/flight.png';
import fashion from '../assets/fashion.png';
import electronic from '../assets/electronics.png';
import beauty from '../assets/beauty.png';
import food from '../assets/food.png';
import recharge from '../assets/recharge.png';
import travel from '../assets/travel.png';
import gadgets from '../assets/gadgets.png';
import books from '../assets/books.png';
import sports from '../assets/sports.png';
import storeData from "../data/storeData.json";

const popularCategories = [
  { name: "Flight", coupons: 477, offers: 715, icon: flight },
  { name: "Fashion", coupons: 1163, offers: 4873, icon: fashion },
  { name: "Electronics", coupons: 288, offers: 1894, icon: electronic },
  { name: "Beauty", coupons: 1269, offers: 4293, icon: beauty },
  { name: "Food", coupons: 563, offers: 2123, icon: food },
  { name: "Recharge", coupons: 412, offers: 1509, icon: recharge },
  { name: "Travel", coupons: 894, offers: 3240, icon: travel },
  { name: "Gadgets", coupons: 156, offers: 874, icon: gadgets },
  { name: "Books", coupons: 320, offers: 1200, icon: books },
  { name: "Sports", coupons: 450, offers: 2100, icon: sports },
];

export default function Category() {
  const [selectedLetter, setSelectedLetter] = useState("All");

  // Get all unique categories from storeData
  const allCategories = [...new Set(
    Object.values(storeData).flatMap(store => store.categories)
  )].sort((a, b) => a.localeCompare(b));

  // Filter categories based on letter
  const filteredCategories = selectedLetter === "All"
    ? allCategories
    : allCategories.filter(cat => cat.toUpperCase().startsWith(selectedLetter));

    // Function to get today's date minus 2 days in DD/MM/YYYY format
const getVerifiedDate = () => {
  const today = new Date();
  const verifiedDate = new Date(today);
  verifiedDate.setDate(today.getDate() - 2);

  const day = String(verifiedDate.getDate()).padStart(2, "0");
  const month = String(verifiedDate.getMonth() + 1).padStart(2, "0");
  const year = verifiedDate.getFullYear();

  return `${day}/${month}/${year}`;
};

  return (
    <div className="category-page font-sans">
      <div className="category-header">
        <div className="category-stats">
          <div className="stats-title">ALL CATEGORIES</div>
          <div className="stats-details">
            <p>Total Categories: <strong>{allCategories.length}</strong></p>
            <p>Total Coupons & Offers: <strong>92,586</strong></p>
            <p className="verified">✔ Verified On: {getVerifiedDate()}</p>
          </div>
        </div>
        <div className="category-banner">
          <a href="https://www.nexaexperience.com/e-vitara">
          <img src={ad} alt="All Categories" /></a>
        </div>
      </div>

      <div className="category-info">
        <h1>All Categories</h1>
        <p>
          If there’s a deal out there, we already found it for you. CouponLagao is
          India’s coupon destination, bringing you the best deals on flights,
          fashion, food, gadgets, entertainment, and more.
        </p>
      </div>

      <div className="category-section">
        <h2>Popular Categories</h2>
        <div className="popular-grid">
          {popularCategories.map((c, idx) => (
            <Link
              to={`/category/${c.name.toLowerCase()}`}
              key={idx}
              className="popular-card"
            >
              <img src={c.icon} alt={c.name} />
              <h3>{c.name}</h3>
              <p>{c.coupons} Coupons | {c.offers} Offers</p>
            </Link>
          ))}
        </div>
      </div>

      <div className="category-section browse-categories">
        <h2>Browse All Categories</h2>

        {/* Alphabet Filter */}
        <div className="alphabet">
          {["All","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","R","S","T","U","V","W","X","Y","Z"].map((letter, idx) => (
            <span
              key={idx}
              className={selectedLetter === letter ? "active" : ""}
              onClick={() => setSelectedLetter(letter)}
            >
              {letter}
            </span>
          ))}
        </div>

        {/* Filtered Categories */}
        <div className="category-list">
          {filteredCategories.map((category, idx) => (
            <Link
              key={idx}
              to={`/category/${category.toLowerCase()}`}
              className="category-item"
            >
              {category}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
